import React from 'react';

/**
 * Subtle build marker pinned to the bottom of every page, so it is always
 * clear which commit the running frontend was built from.
 */
export function BuildInfo() {
  return (
    <div className="build-info" title={`Build ${__GIT_COMMIT__}`}>
      build {__GIT_COMMIT__}
    </div>
  );
}
